import type { EventFor } from '@/types/gql.generated';
import type { CollectionBase } from '../types';

export const baseToFor = (base: CollectionBase | null): EventFor => {
  if (!base) {
    return {};
  }
  if (base.chat) {
    return {
      chatId: base.chat.id,
    };
  }
  if (base.job) {
    return {
      magicJobId: base.job.id,
    };
  }
  if (base.experience) {
    return {
      experienceId: base.experience.id,
    };
  }
  return {};
};

export const getBaseId = (base: CollectionBase): string => {
  if (base.chat) {
    return base.chat.id;
  }
  if (base.job) {
    return base.job.id ?? '';
  }
  if (base.experience) {
    return base.experience.id;
  }
  throw new Error('Invalid CollectionBase: no valid property found');
};

export const baseToId = (base: CollectionBase): string => {
  const baseId = getBaseId(base);

  if (base.chat) {
    return `chat_${baseId}`;
  }
  if (base.experience) {
    return `exp_${baseId}`;
  }
  if (base.job) {
    return `job_${baseId}`;
  }
  return 'undefined';
};
